class CemexTrackingTicket {
  constructor({
    ticketSourceCode,
    productDesc,
    totalDeliveredQuantity,
    ticketStatusCode,
    deliveryDateTime,
    loadNumber,
    truckPlate,
    unitOfMeasure,
  }) {
    this.ticketSourceCode = ticketSourceCode;
    this.productDesc = productDesc;
    this.totalDeliveredQuantity = totalDeliveredQuantity;
    this.ticketStatusCode = ticketStatusCode;
    this.deliveryDateTime = deliveryDateTime;
    this.loadNumber = loadNumber;
    this.truckPlate = truckPlate;
    this.unitOfMeasure = unitOfMeasure;
  }
}

class CemexTrackingOrder {
  constructor({
    orderStatusGroupCode,
    programedDateTime,
    totalQuantity,
    deliveredQuantity,
    totalLoads,
    totalDeliveries,
    orderId,
    orderCode,
    tickets,
    unitOfMeasure,
  }) {
    this.orderStatusGroupCode = orderStatusGroupCode;
    this.programedDateTime = programedDateTime;
    this.totalQuantity = totalQuantity;
    this.deliveredQuantity = deliveredQuantity;
    this.totalLoads = totalLoads;
    this.totalDeliveries = totalDeliveries;
    this.orderId = orderId;
    this.orderCode = orderCode;
    this.tickets = tickets;
    this.unitOfMeasure = unitOfMeasure;
  }
}

export { CemexTrackingOrder, CemexTrackingTicket };
